import React from 'react'
import {useState, useEffect, useMemo, useContext} from 'react';
import styled from 'styled-components'
import { dataLayer } from './utils/dataLayer'
import MapGL, { Source, Layer, NavigationControl } from 'react-map-gl';
import { GlobalContext } from '../GlobalContext';

import { selectCountries, drawLines } from './utils/parseLayers'
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from 'mapbox-gl';

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const MAPBOX_TOKEN = 'pk.eyJ1IjoianVhbmRhbnMiLCJhIjoiY2tubjg1cDJ0MG41eDJ3cDF6N2ZkcGhneiJ9.vvwCV0YWVIgKQv2Xn_j6eQ'

const Map = () => {
  const [viewport, setViewport] = useState({
    latitude: 42.35,
    longitude: -70.9,
    zoom: 1,
    bearing: 0,
    pitch: 0
  })

  const {
    country,
    countries,
    pathways,
    data,
    activePathway,
    setCountry,
  } = useContext(GlobalContext)

  const [allCountries, setCountries] = useState(null)
  // const [year, setYear] = useState(2015);
  // const [hoverInfo, setHoverInfo] = useState(null);

  useEffect(() => {
    /* global fetch */
    fetch(
      'countries_zip.geojson'
    , {
      headers : {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    })
      .then(resp => resp.json())
      .then(json => setCountries(json));
  }, []);

  const filledCountries = useMemo(() => {

    if (!allCountries || !data || !countries) {
      return false
    }

    const sentPathways = country ? pathways : data?.pathways;

    //TODO filters here
    return allCountries && selectCountries(
        sentPathways,
        allCountries,
        countries,
        country
    )


  }, [allCountries, pathways, countries, country]);

  const lines = useMemo(() => {

    if (!data || !countries ) {
      return false
    }
    const sentPathways = country ? pathways : data?.pathways;
    //TODO filters here
    return drawLines(sentPathways, countries)
  }, [pathways, countries]);


  const activeLines = useMemo(() => {
    if (!data || !countries || !activePathway) {
      return false
    }

    return drawLines([activePathway], countries)

  }, [data, countries, activePathway, country])

  const navControlStyle= {
    right: 10,
    bottom: 100
  };

  const handleClick = (e) => {
    const { features } = e;
    
    if (!!features.length) {
      const [item, ] = features;
      if (item?.properties?.['ISO_A3']) {
        const newCountry = countries?.find((country) => country.iso_a3 === item?.properties?.['ISO_A3']);
        if (newCountry) setCountry(newCountry.value);
      }
    }
  };

  return (
    <MapWrapper>
      <MapGL
        {...viewport}
        width="100%"
        height="100%"
        mapStyle="mapbox://styles/mapbox/light-v10"
        onViewportChange={setViewport}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        interactiveLayerIds={['countries', 'countries-border']}
        scrollZoom={false}
        showZoom={true}
        onClick={handleClick}
      >
         <NavigationControl style={navControlStyle} />
        {/* countries fill */}
        <Source type="geojson" data={filledCountries}>
          <Layer 
            id='countries'
            {...{
            id: 'countries',
            type: 'fill',
            paint: {
              'fill-color': '#fdb049',
              'fill-opacity': 0.5,
            }
          }} />
        </Source>

        {/* countries border */}
        <Source type="geojson" data={filledCountries}>
          <Layer
            {...{
            id: 'countries-border',
            type: 'line',
            paint: {
              "line-color": "#fdb049",
              "line-width": 1,
              "line-opacity": 1
            }
          }} />
        </Source>

        {/* lines */}
        <Source type="geojson" data={lines}>
          <Layer {...{
            id: 'lines',
            type: 'line',
            paint: {
              "line-color": "#424242",
              "line-width": 0.8,
              "line-opacity": 0.6
            }
          }} />
        </Source>

         {/* active lines */}
         { activePathway 
         ? (
          <Source type="geojson" data={activeLines}>
            <Layer {...{
              id: 'active-lines',
              type: 'line',
              paint: {
                "line-color": "#00687F",
                "line-width": 2.5,
                "line-opacity": 0.8
              }
            }} />
          </Source>
         ) : null }

      </MapGL>
    </MapWrapper>
  )
}

const MapWrapper = styled.div`
  height: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`

export default Map
